export const levelLabels = ['', 'LOW', 'MEDIUM', 'HIGH'];
export const colors = {
    reputational: {active: '#8E59FF', inActive: '#8E8E8E'},
    commercial: {active: '#43C19B', inActive: '#8E8E8E'},
};
export const rotationDegrees = [159, -110, -20];
